import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-timeline-group', {
  mixins: [eventListenerMixin],

  properties: {
    groupId: String,
  },

  connected() {
    this.timeline = document.querySelector('tr-project-timeline');
    this.sidebarGroup = this.timeline.querySelector(
      `tr-project-timeline-sidebar [data-hover-id="${this.id}"]`,
    );

    if (!this.sidebarGroup) return;
    this.listenTo(this, {
      mouseenter: () => this.sidebarGroup.classList.add('hover'),
      mouseleave: () => this.sidebarGroup.classList.remove('hover'),
    });
  },

  toggle() {
    [].forEach.call(
      this.timeline.querySelectorAll(`tr-project-timeline-todo[group-id="${this.groupId}"]`),
      (todo) => {
        todo.classList.toggle('hide');
      },
    );

    [].forEach.call(document.querySelectorAll('tr-project-timeline-dependency'), el => el.render());
  },

  disconnected() {
    this.stopListening();
  },
});
